/* eslint-disable sciencepo-rules/require-story*/
/* Ce composant ce test plus facilement avec ses composants parents*/

import * as navStyles from '../../styles/layout/transversal-nav-nojs.module.scss';

import React, {Fragment, useEffect} from 'react';
import PropTypes from 'prop-types';
import IconContainer from '../shared/IconContainer';
import PolyLink from '../shared/PolyLink';
import {capitalize} from 'lodash';
import clsx from 'clsx';
import {useTranslation} from 'react-i18next';
import {handleMenuMouseLeave} from '../../services/menuEventUtils';

const NestedItem = React.memo(function NestedItem ({ menu, maref}) {
  const { t } = useTranslation( );
  const [idFocus, setIdFocus] = React.useState(null);

  useEffect(() => {
    for (const child of maref.current.children) {
      child.classList.remove(navStyles.nojs);
    }
  }, [maref]);

  const [openMenu, setOpenMenu] = React.useState(false);

  let mouseTarget = null;

  let addOnClickEvent = () => {
    return null;
  };

  const resetStyles = () => {
    mouseTarget.classList.remove(navStyles.js);
  };

  if (typeof window !== 'undefined') {
    addOnClickEvent = (id) => {
      mouseTarget = document.getElementById(id);
      handleMenuMouseLeave('navigationTransversal', resetStyles);
      for (const child of maref.current.children) {
        if (child.id === id) {
          child.classList.toggle(navStyles.js);
        } else {
          child.classList.remove(navStyles.js);
        }
      }
    };
  }

  let addClickonKeyUp = () => {
    return null;
  };

  if (typeof window !== 'undefined') {
    addClickonKeyUp = (event, id) => {
      event.preventDefault();
      const target = document.getElementById(id);
      // if (target.lastChild.contains(document.activeElement)) {
      // }

      if (event.key === 'Tab') {
        if (target.children.length === 1) {
          target.addEventListener('focusout', () => target.click());
        }
        if (!openMenu) {
          target.click();
          setIdFocus(id);
          setOpenMenu(true);
        }
        if (id !== idFocus && idFocus !== null) {
          target.click();
          setIdFocus(id);
          setOpenMenu(true);
        }
      }
    };
  }

  return (
    <Fragment>
      {menu.map((item, currentIndex) => {
        if (item.subMenuItems?.length > 0) {
          return (
            <button
              className={
                clsx(navStyles.dropdownCategory, navStyles.menuItem, navStyles.nojs)
              }
              data-cy="button-transversal-level1"
              id={'NestedItem' + currentIndex}
              key={currentIndex}
              onClick={() => addOnClickEvent('NestedItem' + currentIndex)}
              onKeyUp={(event) => addClickonKeyUp(event, 'NestedItem' + currentIndex)}
              tabIndex={0}
            >
              <div className={navStyles.nestedMenuTitle}>
                <PolyLink
                  ariaLabel={t(item.title.toUpperCase())}
                  id={`sub-menu-item-${currentIndex}}`}
                  notFocus
                  style={{color: 'inherit'}}
                  target="_blank"
                  url={item.url}
                >
                  {t(item.title.toUpperCase())}
                </PolyLink>
                <IconContainer
                  color="WHITE"
                  icon="ARROW_DOWN_SMALL"
                  noHover
                  notFocus
                  size={15}
                  tabIndex={-1}
                />
              </div>
              <ul
                className={clsx(navStyles.dropdownMenu, navStyles.nestedSubMenu)}
              >
                {item.subMenuItems?.map((subItem, subCurrentIndex, subArray) => {
                  return (
                    <li
                      aria-controls={`nested-html-sub-menu-item-${currentIndex}-${subCurrentIndex}`}
                      data-title={capitalize(subItem.title)}
                      key={`nested-html-sub-menu-item-${currentIndex}-${subCurrentIndex}`}
                    >
                      <PolyLink
                        ariaLabel={subItem.title}
                        className={clsx(navStyles.subMenuTitle, {[navStyles.targetBlank]: subItem.new_window})}
                        dataCy="link-transversal-level2"
                        id={`nested-html-sub-menu-item-${currentIndex}-${subCurrentIndex}`}
                        tabIndex="0"
                        target={subItem.new_window ? '_blank' : '_self'}
                        url={subItem.url || '#'}
                      >
                        {capitalize(subItem.title)}
                      </PolyLink>
                      {subCurrentIndex !== subArray.length - 1 && (
                        <div className={navStyles.lineDivider}/>)}
                    </li>
                  );
                })}
              </ul>
            </button>
          );
        }
        return (
          <button
            className={clsx(navStyles.dropdownCategory, navStyles.menuItem, navStyles.nojs)}
            data-cy="link-transversal-level1"
            id={'NestedItem' + currentIndex}
            key={currentIndex}
            onClick={() => addOnClickEvent('NestedItem' + currentIndex)}
            onKeyUp={(event) => addClickonKeyUp(event, 'NestedItem' + currentIndex)}
            tabIndex={-1}
          >
            <PolyLink
              ariaLabel={t(item.title.toUpperCase())}
              className={clsx(navStyles.nestedMenuTitle, {[navStyles.targetBlank]: item.new_window})}
              id={`sub-menu-item-${currentIndex}}`}
              target={item.new_window ? '_blank' : '_self'}
              url={item.url || '#'}
            >
              {t(item.title.toUpperCase())}
            </PolyLink>
          </button>
        );

      })}
    </Fragment>
  );
});

NestedItem.propTypes = {
  maref: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any })
  ]).isRequired,
  menu: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    title: PropTypes.string.isRequired,
    subMenuItems: PropTypes.arrayOf(PropTypes.shape({
      url: PropTypes.string,
      title: PropTypes.string.isRequired,
    })),
  })).isRequired,
};


export default NestedItem;
